import { useEffect } from 'react';
import { Keyboard } from '@capacitor/keyboard';
import { Capacitor } from '@capacitor/core';
import style from "./useChromeKeyboardFix.module.scss";

export const isAndroidChrome =
    /Android/.test(navigator.userAgent) &&
    /Chrome/.test(navigator.userAgent) &&
    !/Edg|OPR/.test(navigator.userAgent);





export function useChromeKeyboardFix()
{
    useEffect(() =>
    {
        /* 
         TODO: bisher leider noch keine lösung für Android Chrome gefunden 
        Problem:wenn die Virtuelle Tastatur aufgeht wird der html höhe angepasst und der Swiper auch

        beim Swiper die attribute observer usw. setzt hat leider auch nicht geholfen 

        //observer={false}
        //observeParents={false}
        //resizeObserver={false}
        */
        /* 
        const isNativeApp = Capacitor.isNativePlatform();     
       
       function updateViewportHeight()
        {
            const vh = window.visualViewport?.height || window.innerHeight;
            console.log("updateViewportHeight vh: ", vh);
            document.documentElement.style.setProperty('--app-height', `${vh}px`);
        }
        if (isAndroidChrome && !isNativeApp) {
            window.visualViewport?.addEventListener('resize', () =>
            {
                console.log("visualViewport resize:");
                updateViewportHeight();
            });
            window.addEventListener('resize', () =>
            {
                console.log("window resize:");
                updateViewportHeight();
            });
 
            updateViewportHeight();
        }
 
        return () =>
        {
            window.visualViewport?.removeEventListener('resize', updateViewportHeight);
            window.removeEventListener('resize', updateViewportHeight);
        }; */

    }, []);
}
